module.exports = __webpack_public_path__ + "img/ic_16_filter.443feb74.svg";